// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsCustomGameAddBody = {
  poolId: string;
  title?: string | null;
  transactionId: string;
};

export type typeStripsCustomGameAddOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    stripCardId: string;
    title: string;
    isNew: boolean;
  };
};

export type typeStripsCustomGameAddOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsCustomGameAddOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsCustomGameAddOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsCustomGameAddBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    title: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    transactionId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "transactionId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsCustomGameAdd(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsCustomGameAddBody);
  }

  return async function postStripsCustomGameAdd(
    payload: typeStripsCustomGameAddBody,
  ): Promise<
    typeStripsCustomGameAddOutput200 | typeStripsCustomGameAddOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsCustomGameAdd" failed before calling the network. #ab60cc80a831`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#ab60cc80a831" },
        },
        data: null,
      } as typeStripsCustomGameAddOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/custom-game-add`,
      httpMethod: "POST",
      options,
    })) as typeStripsCustomGameAddOutput200 | typeStripsCustomGameAddOutput400;
  };
}
